import { Slide } from "react-awesome-reveal"
import About from "../components/About/About"
import Contact from "../components/Contact/Contact"
import Education from "../components/Education/Education"
import Footer from "../components/Footer/Footer"
import Home from "../components/Home/Home"
import Navbar from "../components/Navbar/Navbar"
import Projects from "../components/Projects/Projects"
import Snowfall from "react-snowfall"

const Portfolio = () => {
  
    const checkIsChristmas = (): boolean => {
      const today = new Date();
      const month = today.getMonth();
      const day = today.getDate();
  
      return month === 11 || (month === 0 && day <= 10);
    };
  
    const isChristmas = checkIsChristmas();
  

  return (
    <>
        <Navbar />
        
        {isChristmas && (
          <Snowfall 
            style={{
              position: 'fixed',
              width: '100vw',
              height: '100vh',
              zIndex: 1, 
              pointerEvents: 'none' 
            }}
            snowflakeCount={100}
          />
        )}

        <Home />

        <Slide triggerOnce={true} direction="up" fraction={0.1}>
        <About />
        </Slide>

        <Slide triggerOnce={true} direction="up" fraction={0.1}>
        <Education />
        </Slide>

        <Slide triggerOnce={true} direction="up" fraction={0.1}>
        <Projects />
        </Slide>

        <Slide triggerOnce={true} direction="up" fraction={0.1}>
        <Contact />
        </Slide>

        <Footer />
    </>
  )
}

export default Portfolio